export default __webpack_public_path__ + "static/IBMPlexSans-Light-4e4ba8673ef515abe4e983eb4b453099.woff2";